import { useContext } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//
import TemaProvider, { TemaContext } from './context/Tema';
//
import AllRoutes from './routes';

/**
 * Precisa ser um componente separado para poder ler o TemaContext: um hook só
 * enxerga o provider se estiver abaixo dele na árvore.
 *
 * O theme="colored" anterior pintava o toast inteiro de vermelho/verde, o que
 * destoa do SGM — lá as notificações seguem a superfície do tema e usam cor só
 * no ícone e na barra de progresso.
 */
function Notificacoes() {
  const { modo } = useContext(TemaContext);

  return (
    <ToastContainer
      position="bottom-center"
      autoClose={5000}
      draggable
      theme={modo}
      toastStyle={{
        background: 'var(--card)',
        color: 'var(--foreground)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        boxShadow: 'var(--card-shadow)',
        fontFamily: 'inherit',
        fontSize: '0.875rem',
      }}
    />
  );
}

function App() {
  return (
    <TemaProvider>
      <Notificacoes />
      <AllRoutes />
    </TemaProvider>
  );
}


export default App;
